(() => {
  const hero = document.querySelector('[data-h-hero]');
  if (hero) {
    const slides = Array.from(hero.querySelectorAll('[data-h-slide]'));
    const dots = Array.from(hero.querySelectorAll('[data-h-hero-dot]'));
    let active = 0;
    let timer;
    const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const show = (index) => {
      if (!slides.length) return;
      active = (index + slides.length) % slides.length;
      slides.forEach((slide, i) => {
        slide.classList.toggle('is-active', i === active);
        slide.setAttribute('aria-hidden', i === active ? 'false' : 'true');
        slide.inert = i !== active;
        slide.querySelectorAll('a').forEach((link) => { link.tabIndex = i === active ? 0 : -1; });
      });
      dots.forEach((dot, i) => {
        dot.classList.toggle('is-active', i === active);
        if (i === active) dot.setAttribute('aria-current', 'true'); else dot.removeAttribute('aria-current');
      });
      slides[(active + 1) % slides.length].querySelector('img')?.setAttribute('loading', 'eager');
    };
    const reset = () => {
      clearInterval(timer);
      if (slides.length > 1 && !motion.matches && !document.hidden && !hero.matches(':focus-within')) timer = setInterval(() => show(active + 1), 6000);
    };
    hero.querySelector('[data-h-hero-prev]')?.addEventListener('click', () => { show(active - 1); reset(); });
    hero.querySelector('[data-h-hero-next]')?.addEventListener('click', () => { show(active + 1); reset(); });
    dots.forEach((dot, i) => dot.addEventListener('click', () => { show(i); reset(); }));
    hero.addEventListener('focusin', () => clearInterval(timer));
    hero.addEventListener('focusout', () => requestAnimationFrame(reset));
    document.addEventListener('visibilitychange', reset);
    motion.addEventListener('change', reset);
    document.addEventListener('shopify:block:select', event => {
      const index = slides.findIndex(slide => slide === event.target || slide.contains(event.target));
      if (index >= 0) { show(index); clearInterval(timer); }
    });
    document.addEventListener('shopify:block:deselect', reset);
    show(0); reset();
  }
  const initPromises = (root = document) => {
    root.querySelectorAll('[data-h-promise]').forEach(viewport => {
      if (viewport.dataset.initialized) return;
      viewport.dataset.initialized = 'true';
      const track = viewport.querySelector('.h-promise-track');
      const group = viewport.querySelector('.h-promise-group');
      if (!group?.children.length) return;
      const copy = group.cloneNode(true);
      copy.classList.add('is-clone');
      copy.setAttribute('aria-hidden', 'true');
      copy.inert = true;
      copy.querySelectorAll('[data-shopify-editor-block]').forEach(item => item.removeAttribute('data-shopify-editor-block'));
      track.append(copy);
      const size = () => viewport.style.setProperty('--promise-width', `${viewport.clientWidth}px`);
      size();
      if ('ResizeObserver' in window) {
        const observer = new ResizeObserver(size);
        observer.observe(viewport);
        const unload = event => {
          if (event.target.contains(viewport)) {
            observer.disconnect();
            document.removeEventListener('shopify:section:unload', unload);
          }
        };
        document.addEventListener('shopify:section:unload', unload);
      } else window.addEventListener('resize', size);
      track.classList.add('is-looping');
    });
  };
  initPromises();
  document.addEventListener('shopify:section:load', event => initPromises(event.target));
  const videos = Array.from(document.querySelectorAll('.h-video-card video'));
  videos.forEach((video) => {
    video.muted = true;
    video.playsInline = true;
    const sound = video.parentElement.querySelector('[data-h-sound]');
    const card = video.closest('.h-video-card');
    const play = card.querySelector('[data-h-play]');
    let manuallyPaused = false;
    const showPlay = () => {
      card.classList.remove('is-playing');
      if (play) play.hidden = false;
    };
    const start = () => {
      if (video.error) video.load();
      const request = video.play();
      request?.catch(showPlay);
    };
    video.addEventListener('playing', () => {
      card.classList.add('is-playing');
      card.classList.add('has-played');
      if (play) play.hidden = true;
    });
    video.addEventListener('pause', () => {
      manuallyPaused = card.dataset.inView === 'true' && !document.hidden;
      showPlay();
    });
    video.addEventListener('error', () => {
      showPlay();
      if (play) play.textContent = card.dataset.retryLabel;
    });
    play?.addEventListener('click', () => { manuallyPaused = false; start(); });
    card.startVideo = () => { if (!manuallyPaused) start(); };
    sound?.addEventListener('click', () => {
      const unmute = video.muted;
      videos.forEach((other) => {
        if (other !== video) {
          other.muted = true;
          other.parentElement.querySelector('[data-h-sound]')?.setAttribute('aria-label', 'Unmute video');
        }
      });
      video.muted = !unmute;
      sound.setAttribute('aria-label', unmute ? 'Mute video' : 'Unmute video');
      if (video.paused) { manuallyPaused = false; start(); }
    });
  });
  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries) => entries.forEach(({ target, isIntersecting }) => {
      const card = target.closest('.h-video-card');
      card.dataset.inView = String(isIntersecting);
      if (document.hidden || !isIntersecting || window.matchMedia('(prefers-reduced-motion: reduce)').matches) target.pause();
      else card.startVideo();
    }), { threshold: 0.1 });
    videos.forEach((video) => observer.observe(video));
  }
  document.addEventListener('visibilitychange', () => {
    videos.forEach(video => {
      if (document.hidden) video.pause();
      else if (video.closest('.h-video-card').dataset.inView === 'true' && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) video.closest('.h-video-card').startVideo();
    });
  });
})();
